<template>
  <div class="track-item">
    <div class="track-name">
      <span>{{ data.operatorName }}</span>
    </div>
    <div class="track-info">
      <p>{{ data.created | dateFormat }}</p>
      <pre>{{ data.content }}</pre>
      <van-row class="img-wrap" v-if="data.image">
        <van-col v-for="image in data.image.split(',')" :key="image" :span="6">
          <ShowImage :url="image" />
        </van-col>
      </van-row>
      <div class="customer">
        <van-tag @click="$router.push({ name: 'CustomerDetails', query: { id: data.customerId } })">{{ data.customerName }}</van-tag>
      </div>
    </div>
  </div>
</template>

<script>
import ShowImage from '@/components/img/showImage'
export default {
  name: 'TrackItem',
  components: { ShowImage },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
  .track-item { background-color: #fff; margin-bottom: 10px; padding: 10px; color: #969799;
    .track-name { color: #333; font-size: 14px; }
    .track-info {
      p { line-height: 18px; font-size: 12px; }
      pre { margin: 0; font-size: 12px; }
      .customer { margin-top: 5px; }
    }
    &:last-of-type { margin-bottom: 0; }
  }
</style>